const PUBLIC_PATHS = {
	HOME: '/home',
	GENERAL: '/general',
	ERROR: '/error',
};

export default PUBLIC_PATHS;
